
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_7098","data-name":"Group 7098"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_1175","data-name":"Path 1175","d":"M23.67 4.25L19.5 8.42a2.1 2.1 0 003 3l4.18-4.18A11.4 11.4 0 1143.13 23l-.36.37-4.18 4.17a2.1 2.1 0 003 3l4.18-4.17A15.61 15.61 0 0023.68 4.25z"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_1176","data-name":"Path 1176","d":"M7.55 26.33l4.17-4.19a2.09 2.09 0 00-3-3l-4.15 4.21a15.61 15.61 0 0022.08 22.08l4.17-4.19a2.14 2.14 0 00.64-1.49 2.12 2.12 0 00-2.15-2.09 2.14 2.14 0 00-1.45.61l-4.18 4.17A11.4 11.4 0 017.56 26.33z"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_1177","data-name":"Path 1177","d":"M32.65 19.46a2.11 2.11 0 00-2.15-2.09 2.09 2.09 0 00-1.45.6L18.3 28.72a2.1 2.1 0 003 3L32 20.94a2 2 0 00.65-1.48z"}})])])
          )
        }
      }
    